import { unwrapEnvelopeOr } from '@/model/client';
import { useGetApiWorkspacesByIdCreditsSummaryQuery } from '@/model/credits/api.generated';
import type { CreditsSummary } from '@/model/credits/dto.generated';
import { skipToken } from '@reduxjs/toolkit/query/react';

export interface UseCreditsSummaryResult {
  summary: CreditsSummary | null;
  isLoading: boolean;
}

export function useCreditsSummary(
  workspaceId?: string,
  pollingInterval = 0,
): UseCreditsSummaryResult {
  const { currentData, isLoading, isUninitialized } = useGetApiWorkspacesByIdCreditsSummaryQuery(
    workspaceId ? { id: workspaceId } : skipToken,
    { pollingInterval },
  );

  return {
    summary: unwrapEnvelopeOr<CreditsSummary | null>(currentData, null),
    isLoading: Boolean(workspaceId) && (isLoading || isUninitialized),
  };
}
